<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import { Table } from 'sveltestrap'
    import {Link} from 'svelte-routing'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getFilterActions, undoActions} from 'src/components/cabinet/#services/adminActions'
    import {getAllAdminsList} from 'src/components/cabinet/#services/getAdminsList'
    import {getActionList} from 'src/components/cabinet/#services/getActionList'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {myRole} from 'src/components/#common/myRole'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'

    let currentPage = 0
    let perPage = 25
    let maxButtons = 5

    let action = 'all'
    let administrator = 'all'
    let fromDate = 'firstDate'
    let toDate = 'lastDate'
    let isDisabled = false
    let showDetailsModal = false
    let showCancelAction = false
    let modalParams = {}
    let idForAction = ""

    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    maxDate = yyyy+'-'+mm+'-'+dd
    let yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1);

    getFilterActions.send({data:{
        agent: action,
        userId: '',
        nickname: administrator,
        firstDate: fromDate,
        lastDate: toDate,
        page: currentPage + 1,
        perPage
    }})

    getAllAdminsList.reset()
    getAllAdminsList.send()
    getActionList.reset()
    getActionList.send()

    function filter() {
        getFilterActions.send({data: {
            method: action,
            userId: '',
            nickname: administrator,
            firstDate: fromDate,
            lastDate: toDate,
            page: currentPage + 1,
            perPage
        }})
    }

    $:currentPage,perPage,filter()

    function splitNickname(nickname) {
        return nickname.replace(/#([^#]+)$/, '')
    }

    const actionsDisplayNames = {
        "mailTemplate_create": "Created Mail Template",
        "mailTemplate_delete": "Deleted Mail Template",
        "mailTemplate_change": "Changed Mail Template",
        "userRole_add": "Assigned role",
        "userRole_updateUserRole": "Changed user role",
        "userRole_deleteUserRole": "Deleted role from user",
        "role_add": "Created role",
        "permission_updatePermissions": "Updated role",
        "role_delete": "Deleted role",
        "option_set": "Set new options settings",
        "option_unset": "Unset options settings",
        "option_updateAll": "Updated options settings",
        "notifications_createNew": "Created new notification",
        "profile_banProfile": "Banned user",
        "profile_unBan": "Unbaned user",
        "profile_setSuspicious": "Set user profile Suspicious",
        "profile_setNotice": "Set user profile Notice",
        "config_add": "Created new membership",
        "config_update": "Updated membership",
        "config_delete": "Deleted membership",
        "config_disable": "Active/Inactive membership",
        "config_updatePriorityIndex": "Changed memberships priority",
        "membership_addAwardMembership": "Set membership to user",
        "membership_changeMembershipGame": "Change game in user membership",
        "membership_disable": "Deleted user membership",
        "balance_adminIncreaseBalance": "Increase LIS balance",
        "balance_adminDecreaseBalance": "Decrease LIS balance",
        "approval_approve": "Confirmation of withdrawal",
        "profile_toggleUserSuspicious": "Change status suspicious",
        "profile_setUserNotice": "Set user profile Notice",
        "accrual_assign": "NFT egg accrual",
    }

    function getActionDisplayName(name:string) {
        return actionsDisplayNames[name] ? actionsDisplayNames[name] : name
    }

    async function undoAction(actionId) {
        try {
            await undoActions.request({ data: { actionId } })
            showCancelAction = false
            showAlert.set({
                status: 'success',
                text: 'Action has been canceled!'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            filter()
        }
    }

    function reset() {
        action = 'all'
        administrator = 'all'
        fromDate = 'firstDate'
        toDate = 'lastDate'
        filter()
    }
</script>

<svelte:head>
    <title>Actions</title>
</svelte:head>

<MainLayout title="Actions">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="buttons">
                    <div class="pc-line">
                        <span class="date-label">Action</span>
                        <select class="form-select" bind:value={action}>
                            {#if $getActionList.loading}
                                <option disabled selected>Loading..</option>
                            {:else if $getActionList.error || !$getActionList.hasValue }
                                <option disabled selected>Error</option>
                            {:else}
                                <option value="all">All</option>
                                {#each $getActionList.value as actions}
                                    <option value={actions}>{getActionDisplayName(actions)}</option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                    <div class="pc-line">
                        <span class="date-label">Administrator</span>
                        <select class="form-select" bind:value={administrator}>
                            {#if $getAllAdminsList.loading}
                                <option disabled selected>Loading..</option>
                            {:else if $getAllAdminsList.error || !$getAllAdminsList.hasValue }
                                <option disabled selected>Error</option>
                            {:else}
                                <option value="all">All</option>
                                {#each $getAllAdminsList.value as {nickname}}
                                    <option value={nickname}>{splitNickname(nickname)}</option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                    <div class="pc-line">
                        <span class="date-label">From</span>
                        <input type="date" bind:value={fromDate} class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <span class="date-label">To</span>
                        <input type="date" bind:value="{toDate}" class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
                        <button class="btn btn-secondary" on:click={reset}>Reset</button>
                    </div>
                </div>
                {#if $getFilterActions.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$getFilterActions.loading || $getFilterActions.loading}
                        totalCount={$getFilterActions.value.totalCount}
                    />
                {/if}
                <div class="actions-list">
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <td class="text-center">Date</td>
                            <td class="text-center">User</td>
                            <td class="text-center">Action</td>
                            <td class="text-center">Details</td>
                            {#if $myRole.hasValue && $myRole?.value?.methods?.includes("cancelActions")}
                            <td class="text-center">Actions</td>
                            {/if}
                        </tr>
                        </thead>
                        <tbody>
                        {#if $getFilterActions.loading}
                            {#each {length:perPage} as item}
                                <tr>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("cancelActions")}
                                    <td><span class="loading transaction-loading"></span></td>
                                    {/if}
                                </tr>
                            {/each}
                        {:else if $getFilterActions.error || !$getFilterActions.hasValue }
                            <tr>
                                <td class="text-center" colspan="5">Something went wrong. Try refreshing the page.</td>
                            </tr>
                        {:else}
                            {#each $getFilterActions.value.data as {createdAt,isCancelable,method,nickname,userId,params,actionId}}
                                <tr>
                                    <td class="text-center nobr">{createdAt.toLocaleString()}</td>
                                    <td class="text-center"><a href="/profile/{userId}" target="_blank" rel="noreferrer">{splitNickname(nickname)}</a></td>
                                    <td>{getActionDisplayName(method)}</td>
                                    <td class="text-center">
                                        <button class="btn btn-secondary" disabled={Object.keys(params).length === 0}
                                            on:click={() => { showDetailsModal = true; modalParams = params}}>Show</button>
                                    </td>
                                    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("cancelActions")}
                                        {#if isCancelable === true && createdAt > yesterday}
                                            <td class="text-center">
                                                <button class="btn btn-primary" disabled={!isCancelable}
                                                    on:click={()=>{showCancelAction = true; idForAction = actionId}}>Cancel</button>
                                            </td>
                                        {:else}
                                            <td></td>
                                        {/if}
                                    {/if}
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                        <Modal bind:visible={showDetailsModal}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Details</div>
                                <div class="modal-custom__text">{@html Object.keys(modalParams).map(key=>`<strong>${key}</strong>: ${JSON.stringify(modalParams[key])}`).join("\n")}</div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { showDetailsModal = false }}>Close</button>
                                </div>
                            </svelte:fragment>
                        </Modal>

                        <Modal bind:visible={showCancelAction}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Cancel action</div>
                                <div class="modal-custom__text">Are you sure you want to undo this action?</div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { showCancelAction = false }}>Close</button>
                                    <button class="btn btn-primary" on:click={undoAction(idForAction)}>Yes</button>
                                </div>
                            </svelte:fragment>
                        </Modal>
                    </Table>
                    {#if $getFilterActions.hasValue}
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getFilterActions.value.totalCount}
                            {perPage}
                            {maxButtons}
                            disabled={$getFilterActions.loading || $getFilterActions.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .buttons {
        margin-bottom: 15px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .pc-line .btn-primary {
        padding: 8px 20px;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    td .btn {
        padding: 6px 20px !important;
        margin: -6px 0 !important;
    }

    td {
        vertical-align: middle;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
        font-weight: 500;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
    }

    .nobr {
        white-space: nowrap;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .date-label {
            font-size: 14px;
        }

        .btn-filter {
            margin-bottom: 10px;
        }
    }
</style>
